import { createContext } from 'react';

import { SpecialistRole, SpecialistType } from 'services/specialist';

import { SpecialistContextProps, SpecialistGroups } from './types';

const INITIAL_STATE: SpecialistContextProps = {
  isAuthenticated: false,
  specialistInfo: null,
  specialistProfessionalInfo: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSpecialistInfo: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setSpecialistProfessionalInfo: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setAuthenticated: () => {},
};

const SpecialistContext = createContext<SpecialistContextProps>(INITIAL_STATE);

const SpecialistConsumer = SpecialistContext.Consumer;
const SpecialistProvider = SpecialistContext.Provider;

const getSpecialistRole = (specialistGroups?: SpecialistGroups) => {
  if (specialistGroups?.includes(SpecialistRole.CP)) {
    return SpecialistRole.CP;
  }
  if (specialistGroups?.includes(SpecialistRole.TC)) {
    return SpecialistRole.TC;
  }

  return undefined;
};

const getSpecialistType = (specialistGroups?: SpecialistGroups) => {
  if (specialistGroups?.includes(SpecialistRole.CP)) {
    return SpecialistType.CP;
  }
  if (specialistGroups?.includes(SpecialistRole.TC)) {
    return SpecialistType.TC;
  }

  return undefined;
};

export {
  SpecialistContext,
  SpecialistConsumer,
  SpecialistProvider,
  getSpecialistType,
  getSpecialistRole,
};
